import { render, staticRenderFns } from "./SuperPassPaymentMethod.vue?vue&type=template&id=23acc18f&scoped=true&"
import script from "./SuperPassPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./SuperPassPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./SuperPassPaymentMethod.vue?vue&type=style&index=0&id=23acc18f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acc18f",
  null
  
)

export default component.exports